import React from 'react';
import { withRouter } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Icon from '@material-ui/core/Icon';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import { MENUS_CONFIG } from '../../shared/config/index';

const useStyles = makeStyles({
	list: {
		width: 250,
	}
});

const Sidebar = props => {
	const classes = useStyles();

	const redirectTo = (menu) => {
		props.history.push(menu.url);
		props.onClose();
	}
 
	return (
		<Drawer open={props.open} onClose={(event) => props.onClose(event)}>
			<AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" className={classes.title}>
                        MSDO Live
                    </Typography>
                </Toolbar>
            </AppBar>

			<List className={classes.list}>
				{MENUS_CONFIG.map(menu => (
					<React.Fragment key={menu.title}>
						<ListItem button onClick={() => redirectTo(menu)}>
							<ListItemIcon><Icon color="primary">{menu.icon}</Icon></ListItemIcon>
							<ListItemText primary={menu.title} />
						</ListItem>
						<Divider />
					</React.Fragment>
				))}
			</List>
		</Drawer>
	)
}

export default withRouter(Sidebar);